import { render, staticRenderFns } from "./InputTextSwitchDialog.vue?vue&type=template&id=63e0e93e&scoped=true&"
import script from "./InputTextSwitchDialog.vue?vue&type=script&lang=js&"
export * from "./InputTextSwitchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0e93e",
  null
  
)

export default component.exports